module.exports = __webpack_public_path__ + "static/media/Bird.2cfe4a82.mp3";